<div *ngIf="actionSetting$ | async as actionSettings">
   <div class="row">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%">{{
         'user_actions.types.open_dynamic_link.settings.url' | translate
      }}</label>
      <input
         fxFlex="60%"
         [value]="actionSettings.url"
         (input)="urlChanged(actionSettings, $event.target.value)"
         kendoTextBox
      />
   </div>

   <div class="row">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%">{{
         'user_actions.types.open_dynamic_link.settings.automatically_open' | translate
      }}</label>
      <kendo-multiselect
         fxFlex="60%"
         [autoClose]="false"
         [data]="possibleAutoOpenTriggers"
         [valuePrimitive]="true"
         textField="translationKey"
         valueField="value"
         [value]="actionSettings.autoOpenTriggers"
         (valueChange)="autoOpenTriggersChanged(actionSettings, $event)"
         placeholder="{{ 'user_actions.types.open_dynamic_link.settings.automatically_open_placeholder' | translate }}"
      >
         <ng-template kendoMultiSelectTagTemplate kendoMultiSelectItemTemplate let-dataItem>
            {{ dataItem.translationKey | translate }}
         </ng-template>
         <ng-template kendoMultiSelectGroupTemplate kendoMultiSelectFixedGroupTemplate let-groupName>
            <strong>{{ groupName | translate }}</strong>
         </ng-template>
      </kendo-multiselect>
   </div>
</div>
